<script>
    import {mapStore} from '@js/stores/mapStore';

    import {computeRideDuration} from '@js/actions/mapActions';

    import I18n from '@js/modules/translations';

    import Computation from '@js/modules/computation';

    import Spinner from '@js/components/themes/Spinner.svelte';
    import Dropdown from '@js/components/themes/Dropdown.svelte';

    import Icon from '@js/components/themes/Icon.svelte';
    import timeIcon from '@js/components/icons/timeIcon';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    import AnalyticsService from '@js/modules/analyticsService';

    let {
        isComputingDuration = $bindable(false),
        displayHelper = true,
        onDurationEstimated
    } = $props();

    const _computeEstimatedDuration = () => {
        if (!mapStore.map) {
            return;
        }

        AnalyticsService.trackMapComputeDuration(mapStore.currentRideType);

        const serializedPoints = mapStore.map.serializePoints();

        computeRideDuration({
            mapPoints: serializedPoints,
            distance: mapStore.currentDistance,
            rideType: mapStore.currentRideType
        })
            .then((result) => {
                if (!result) {
                    return;
                }

                mapStore.currentDuration = result.duration;
                mapStore.durationComputed = false;

                mapStore.currentSpeed = Computation.computeSpeed(mapStore.currentDistance, result.chronoDuration);
                mapStore.speedComputed = true;

                onDurationEstimated(result.chronoDuration);
            })
            .finally(() => {
                isComputingDuration = false;
            });
    };

    const _handleComputeDuration = (event, routeType) => {
        if (event) {
            event.preventDefault();
        }

        if (isComputingDuration) {
            return;
        }

        mapStore.currentRideType = routeType;

        isComputingDuration = true;

        _computeEstimatedDuration();
    };
</script>

<div class="flex items-center justify-center">
    <Dropdown
            buttonClass="px-4 py-2 text-red-700 hover:text-white border border-primary-700 bg-white hover:bg-primary-700 focus:ring-2 focus:outline-hidden focus:ring-primary-300 font-medium rounded-lg text-sm text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
            optionSize={Object.keys(RIDE_TYPE_ICON).length}
            closeClickInside={true}
            disabled={isComputingDuration}
            onClose={() => _handleComputeDuration(null, $mapStore.currentRideType)}>
        {#snippet dropdownButtonRender()}
            <span class="flex items-center justify-center">
                {#if isComputingDuration}
                    <Spinner class="me-3"
                             size="4"
                             color="primary"/>

                    {I18n.t('js.ride.map.estimate_duration.computing')}
                {:else}
                    <Icon class="inline-flex h-4 w-4 me-2"
                          icon={timeIcon}/>

                    {I18n.t('js.ride.map.estimate_duration.button')}
                {/if}
            </span>
        {/snippet}

        <ul class="text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="RouteType">
            <li class="p-2 text-xs text-gray-500 italic">
                {I18n.t('js.ride.map.estimate_duration.menu')}
            </li>

            {#each Object.keys(RIDE_TYPE_ICON) as routeType (routeType)}
                <li class="flex items-center justify-start p-2 cursor-pointer hover:bg-primary-400"
                    class:bg-primary-200={$mapStore.currentRideType === routeType}
                    onclick={(event) => _handleComputeDuration(event, routeType)}>
                    <Icon class="h-4 w-4 me-3"
                          icon={RIDE_TYPE_ICON[routeType]}/>
                    {I18n.t(`js.ride.enums.ride_type.${routeType}`)}
                </li>
            {/each}
        </ul>
    </Dropdown>
</div>

{#if displayHelper}
    <div class="ride-elevation-info p-2 text-xs leading-3 text-center text-gray-500 italic">
        {I18n.t('js.ride.map.estimate_duration.helper')}
    </div>
{/if}
